import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import CommentAction from "./CommentAction";
import CommentInteraction from "./CommentInteraction";
import CommentReplyInteraction from "./CommentReplyInteraction";
import CommentReplyAction from "./CommentReplyAction";
import EditComment from "./EditComment";
import axios from "../../API/axios";
import SingleCommentInteraction from "./SingleCommentInteraction";
import SingleCommentReplyInteraction from "./SingleCommentReplyInteraction";
import SingleCommentAction from "./SingleCommentAction";
import CommentReplyActionSingle from "./CommentReplyActionSingle";

const SingleComment = ({
  isOwnedPost,
  postId,
  AllPostList,
  singlepostList,
  setSinglePostList,
  emojiList,
  setPostList,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  console.log("singlepostList222222222", postId);

  // State for tracking which comment is being edited
  const [editedDynamicValue, setEditedDynamicValue] = useState([])
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingReplyId, setEditingReplyId] = useState(null); // State for reply editing
  const [commentsState, setCommentsState] = useState([]);
  const [postID, setpostId] = useState(postId);

  // useEffect to initialize commentsState when singlepostList is available or updated
  useEffect(() => {
    if (singlepostList?.postInfo?.postInfo?.comments) {
      setCommentsState(
        singlepostList?.postInfo?.postInfo?.comments.map((comment) => ({
          ...comment,
          editedComment: comment.comment, // Store the editable version of comment
          commentsReplies: comment.commentsReplies?.map((reply) => ({
            ...reply,
            editedReply: reply.reply, // Store the editable version of reply
          })),
        }))
      );
    }
  }, [singlepostList?.postInfo]); // Re-run when singlepostList changes


  console.log("singlepostList",singlepostList);
  
  const updateComment = (pstCmntId, newComment) => {
    if (singlepostList?.postInfo?.postInfo?.comments) {
      const updatedComments = singlepostList?.postInfo?.postInfo?.comments?.map(
        (comment) => {
          if (comment.pstCmntId === pstCmntId) {
            return { ...comment, comment: newComment };
          }
          return comment;
        }
      );
      // Update the single post with the modified comments
      setSinglePostList({ ...singlepostList?.postInfo, postComments: updatedComments });
    }
  };

  const handleEdit = (commentId) => {
    setEditingCommentId(commentId); // Set the comment to be edited
  };

  const handleSave = async (commentId) => {
    const commentToEdit = commentsState.find(
      (comment) => comment.pstCmntId === commentId
    );

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntId: commentId,
      comment: commentToEdit.editedComment, // Use the updated comment
      dynamicValues: editedDynamicValue
    };

    try {
      await axios.post(`PostAction/UpdateCommentPost`, responseData);
      updateComment(commentId, commentToEdit.editedComment);
       // Update comment in UI
      setEditingCommentId(null); // Exit edit mode
    } catch (error) {
      console.error("Error saving comment:", error);
    }
  };

  const handleCommentChange = (commentId, newComment) => {
    if (newComment !== "") {
      setCommentsState(
        commentsState.map((comment) =>
          comment.pstCmntId === commentId
            ? { ...comment, editedComment: newComment }
            : comment
        )
      );
    }
  };

  const handleReplyEdit = (replyId) => {
    setEditingReplyId(replyId);
  };

  const handleReplySave = async (commentId, replyId) => {
    const commentToEdit = commentsState.find(
      (comment) => comment.pstCmntId === commentId
    );
    const replyToEdit = commentToEdit.commentsReplies.find(
      (reply) => reply.pstCmntRplyId === replyId
    );

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntRplyId: replyId,
      reply: replyToEdit.editedReply, // Use the updated reply
    };

    try {
      await axios.post(`PostAction/UpdateCommentReply`, responseData);
      setEditingReplyId(null); // Exit reply edit mode
    } catch (error) {
      console.error("Error saving reply:", error);
    }
  };

  const handleReplyChange = (commentId, replyId, newReply) => {
    setCommentsState(
      commentsState.map((comment) =>
        comment.pstCmntId === commentId
          ? {
            ...comment,
            commentsReplies: comment.commentsReplies.map((reply) =>
              reply.pstCmntRplyId === replyId
                ? { ...reply, editedReply: newReply }
                : reply
            ),
          }
          : comment
      )
    );
  };

  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };
  console.log("singlepostList..........", singlepostList);

  const replaceDynamicValues = (content, dynamicValues) => {
    if (!content || !dynamicValues) return content;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
      const replacement =
        item.type === "UserMention"
          ? `<a href="/user/${item.entityID}" class="user-mention">@${item.displayName}</a>`
          : item.type === "Hashtag"
            ? `<a href="/hashtag/${item.entityID}" class="hashtag">#${item.displayName}</a>`
            : item.displayName;

      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };

  const commentedPost = (item) => {
    const formattedContent = linkifyContent(
      addTargetBlankToAnchors(
        replaceDynamicValues(
          item?.editedComment,
          item?.dynamicValues
        )
      )
    );
    return formattedContent;
  }


  console.log("commentsState", commentsState)

  return (
    <>
      <div className="comment-section mt-2">
        {commentsState && commentsState.length > 0 ? (
          commentsState.map((commentItem, index) => (
            <div key={index}>
              <div className="mainComment d-flex mb-4">
                <div>
                  <Link to={`/User/${commentItem.useruid}`}>
                    <div>
                      <img
                        src={commentItem?.userAvatar}
                        width={40}
                        height={40}
                        alt=""
                        style={{
                          borderRadius: "50px",
                          border: "1px solid black",
                        }}
                      />
                    </div>
                  </Link>
                </div>

                <div className="w-100">
                  <div className="userCommentdetail ms-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <h4 className="f-14 fw-bold mb-0">
                        {commentItem?.userName}
                      </h4>
                      <SingleCommentInteraction
                        isOwnedPost={isOwnedPost}
                        item={commentItem}
                        handleSave={() => handleSave(commentItem.pstCmntId)}
                        handleEdit={() => handleEdit(commentItem.pstCmntId)}
                        isEditing={editingCommentId === commentItem.pstCmntId}
                        setPostList={setSinglePostList}
                        postList={singlepostList}
                        postId={postId}
                      />
                    </div>
                    <p className="f-12">
                      {moment
                        .utc(commentItem?.creationTime)
                        .local()
                        .format("DD MMMM YYYY [at] h:mm a")}
                    </p>
                    <div className="commentText mt-2">
                      {editingCommentId === commentItem.pstCmntId ? (
                        <EditComment
                          isEditing={true}
                          editedComment={commentItem.editedComment} // Pass specific edited comment
                          handleCommentChange={(newComment) =>
                            handleCommentChange(
                              commentItem.pstCmntId,
                              newComment
                            )
                          }
                          handleSave={() => handleSave(commentItem.pstCmntId)}
                          setIsEditing={() => setEditingCommentId(null)}
                          dynamicValues={commentItem?.dynamicValues}
                          setEditedDynamicValue={setEditedDynamicValue}
                        />
                      ) : (
                        <>
                          {/* <p className="f-14">{commentItem.editedComment}</p> // Render updated comment */}
                          <div
                            className='postContentDiv'
                            dangerouslySetInnerHTML={{
                              __html: commentedPost(commentItem)
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <SingleCommentAction
                    item={commentItem}
                    postList={singlepostList}
                    AllPostList={AllPostList}
                    emojiList={emojiList}
                    setPostList={setSinglePostList}
                    postId={postId}
                  />
                </div>
              </div>

              {/* Comment Replies */}
              
              {commentItem?.commentsReplies &&
                commentItem?.commentsReplies?.map((reply, replyIndex) => (
                  <div
                  className="mainComment d-flex mb-4 ms-5"
                  key={replyIndex}
                  >
                    { console.log("commentItem99999999", commentItem)}
                    <div>
                      <img
                        src={reply?.userAvatar}
                        width={40}
                        height={40}
                        alt=""
                        style={{
                          borderRadius: "50px",
                          border: "1px solid black",
                        }}
                      />
                    </div>
                    <div className="w-100">
                      <div className="userCommentdetail ms-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <h4 className="f-14 fw-bold mb-0">
                            {reply?.userName}
                          </h4>
                          <SingleCommentReplyInteraction
                            isOwnedPost={isOwnedPost}
                            item={reply}
                            handleReplySave={() =>
                              handleReplySave(
                                commentItem.pstCmntId,
                                reply.pstCmntRplyId
                              )
                            }
                            handleReplyEdit={() =>
                              handleReplyEdit(reply.pstCmntRplyId)
                            }
                            isEditing={editingReplyId === reply.pstCmntRplyId}
                            setPostList={setSinglePostList}
                            postList={singlepostList}
                            postId={postId}
                            commentId={commentItem.pstCmntId}
                          />
                        </div>
                        <p className="f-12">
                          {moment
                            .utc(reply?.creationTime)
                            .local()
                            .format("DD MMMM YYYY [at] h:mm a")}
                        </p>
                        <div className="commentText mt-2">
                          {editingReplyId === reply.pstCmntRplyId ? (
                            <EditComment
                              isEditing={true}
                              editedComment={reply.editedReply} // Pass specific edited reply
                              handleCommentChange={(newReply) =>
                                handleReplyChange(
                                  commentItem.pstCmntId,
                                  reply.pstCmntRplyId,
                                  newReply
                                )
                              }
                              handleSave={() =>
                                handleReplySave(
                                  commentItem.pstCmntId,
                                  reply.pstCmntRplyId
                                )
                              }
                              setIsEditing={() => setEditingReplyId(null)}
                            />
                          ) : (
                            <p className="f-14">{reply.editedReply}</p>
                          )}
                        </div>
                      </div>
                      <CommentReplyActionSingle
                        item={reply}
                        emojiList={emojiList}
                        setPostList={setSinglePostList}
                        postList={singlepostList}
                        postId={postId}
                        commentId={commentItem.pstCmntId}
                      />
                    </div>
                  </div>
                ))}
            </div>
          ))
        ) : (
          // <p>No comments available</p>
          <></>
        )}
      </div>
    </>
  );
};

export default SingleComment;